module.exports = __webpack_public_path__ + "img/7.9cb15ee4.png";